export enum AccessControlType {
  default = 0,
  private = 1,
  public = 2,
  signed = 3,
}
